import { FormField } from "../../components/FormElements/FormFieldsRenderer";

const editPhysician = (t, requiredFields, regionProps) => {
  const patientFormDefinitions = [
    {
      key: 'code'
    },
    {
      key: 'firstName'
    },
    {
      key: 'lastName'
    },
    {
      key: 'profession'
    },
    {
      key: 'address',
      label:  t('common.registrationForm.cabinetAddress')
    }
  ];

  const formFields: FormField[] = patientFormDefinitions.map(field => {
    const { key, label } = field;

    return {
      label: label || t(`common.registrationForm.${key}`),
      prefix: 'doctorProfile',
      isRequired: requiredFields[key],
      fieldType: 'Text',
      isFullWidth: true,
      subType: 'text',
      name: key
    };
  });

  formFields.push(
    {
      label: t(`regionSelector.county`),
      prefix: 'doctorProfile',
      isRequired: true,
      regionProps: regionProps,
      name: 'region',
      fieldType: 'Region'
    },
    {
      label: t(`common.registrationForm.phone`),
      prefix: 'doctorProfile',
      isRequired: requiredFields.phone,
      fieldType: 'Text',
      isFullWidth: true,
      subType: 'text',
      name: 'phone'
    }
  );

  return formFields;
}

export default editPhysician;
